// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-90815ba8]{color:#000;font-size:25px;font-weight:500}@media print,screen and (min-width:769px){.logo[data-v-90815ba8]{font-size:30px}}.pricebar[data-v-90815ba8]{align-items:center;border-bottom:1px solid #3e4cd4;display:flex;justify-content:space-between;padding:15px}@media print,screen and (min-width:769px){.pricebar[data-v-90815ba8]{padding:15px 20%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
